import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
import { Dropdown as RODropdown } from 'react-overlays';
import { default as noop } from '@airtm/utils/dist/utilities/noop';
import { DropdownToggle } from '../DropdownToggle';
import { DropdownMenu } from '../DropdownMenu';
import { DropdownItem } from '../DropdownItem';
export var Dropdown = function (props) {
    var componentClass = 'dropdown';
    var className = props.className, children = props.children, drop = props.drop, alignEnd = props.alignEnd, show = props.show, onToggle = props.onToggle, dropdownProps = __rest(props, ["className", "children", "drop", "alignEnd", "show", "onToggle"]);
    var classes = cx(bcx(componentClass, {}), className);
    return (React.createElement(RODropdown, { drop: drop, alignEnd: alignEnd, show: show, onToggle: onToggle },
        React.createElement("div", __assign({ className: classes }, dropdownProps), children)));
};
Dropdown.defaultProps = {
    drop: 'down',
    alignEnd: true,
    show: false,
    onToggle: noop,
};
Dropdown.Toggle = DropdownToggle;
Dropdown.Menu = DropdownMenu;
Dropdown.Item = DropdownItem;
//# sourceMappingURL=Dropdown.js.map